import { Link } from 'react-router-dom';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useImportedResources } from '@/hooks/api/2620_imported_resources';
import { MotionDiv } from '@/components/element/MotionDiv';
import { ImportedResource } from '@/hooks/api/models';
import moment from 'moment';
import { useMemo } from 'react';

export const ImportedResourcesElement = () => {
  const { _w_ } = useCurrentWorkspace();
  const { data } = useImportedResources({ identifier: _w_!.identifier });

  if (data == null || data.length === 0) {
    return null;
  }

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-1">インポート履歴</h5>
          <p className="text-xs mb-0">
            インポートの履歴が表示されます。ステータスなどの詳細は
            <Link
              to={`https://www.biz-node.app/rd/?wbfrd=manual-import-status`}
              className="text-decoration-underline"
              target="_blank"
              rel="noreferrer"
            >
              こちら
            </Link>
            から確認できます。
          </p>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="table-responsive">
          <table className="table align-items-center">
            <thead>
              <tr>
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  style={{ width: '120px' }}
                >
                  操作日時
                </th>
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  style={{ width: '160px' }}
                >
                  アップロードユーザー
                </th>
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  style={{ width: '140px' }}
                >
                  インポート対象
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">ステータス</th>
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  style={{ width: '120px' }}
                >
                  結果詳細ファイル
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((d, i) => (
                <ImportedResourceRow key={`i_r_${d.id}`} d={d} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </MotionDiv>
  );
};

const ImportedResourceRow = ({ d }: { d: ImportedResource }) => {
  const contextLabel = useMemo(() => {
    if (d.context == 'business_partner') {
      return '取引先';
    } else if (d.context == 'sales_order') {
      return 'プロジェクト（売上）';
    } else if (d.context == 'purchase_order') {
      return 'プロジェクト（費用）';
    } else {
      return '';
    }
  }, [d]);

  const stateLabel = useMemo(() => {
    if (d.state == 'initial') {
      return <span className="badge badge-info">未処理</span>;
    } else if (d.state == 'processing') {
      return <span className="badge badge-warning">処理中</span>;
    } else if (d.state == 'completed') {
      return (
        <>
          <span className="badge badge-success">完了</span>
          <span className="text-xxs font-weight-bold">
            （成功：{d.import_result!.success_counts} / 失敗：{d.import_result!.failure_counts}）
          </span>
        </>
      );
    } else if (d.state == 'invalid_format') {
      return <span className="badge badge-danger">フォーマットエラー</span>;
    } else {
      return <></>;
    }
  }, [d]);

  return (
    <tr>
      <td className="text-secondary text-xxs font-weight-bold">{moment(d.created_at).format('YYYY/MM/DD HH:mm')}</td>
      <td className="text-secondary text-xxs font-weight-bold">{d.user.user_account.name}</td>
      <td className="text-secondary text-xs font-weight-bold">{contextLabel}</td>
      <td className="text-secondary text-xs font-weight-bold">{stateLabel}</td>
      <td>
        {d.state == 'completed' && d.import_result && (
          <a
            href={d.import_result.file_url}
            target="_blank"
            rel="noreferrer"
            className="btn btn-sm bg-gradient-primary px-3"
            download={d.import_result.file_url.split('/').pop()}
          >
            ダウンロード
          </a>
        )}
      </td>
    </tr>
  );
};
